import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import _ from 'lodash';
import RaisedButton from 'material-ui/RaisedButton';
import { List, ListItem } from 'material-ui/List';
import SearchIcon from 'material-ui/svg-icons/action/search';
import TextField from 'material-ui/TextField';
import { Toolbar, ToolbarGroup } from 'material-ui/Toolbar';
import Toggle from 'material-ui/Toggle';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import COLORS from '../../theme/colors';

import './slack_channels.scss';

export default class SlackChannels extends React.Component {
  static propTypes = {
    team: PropTypes.object.isRequired,
    channels: PropTypes.array.isRequired,
    updateBlacklist: PropTypes.func.isRequired,
    addToBlacklist: PropTypes.func.isRequired,
    removeFromBlacklist: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      filterText: '',
    };
  }

  getSlackChannels() {
    return this.props.channels
      .filter(channel => channel.name.indexOf(this.state.filterText) !== -1)
      .map((channel) => {
        const toggle = (
          <Toggle
            toggled={!channel.blacklisted}
            onToggle={(event, checked) => {
              const { addToBlacklist, removeFromBlacklist } = this.props;
              const action = checked
                ? removeFromBlacklist
                : addToBlacklist;

              action(channel.id);
            }}
          />
        );

        return (<ListItem
          style={{ borderBottom: `1px solid ${COLORS.gray}` }}
          key={channel.id}
          primaryText={`#${channel.name}`}
          rightToggle={toggle}
        />);
      });
  }

  render() {
    const { team } = this.props;
    const selectAllButton = (
      <RaisedButton
        labelColor={COLORS.purple}
        label="All"
        onClick={() => {
          const removeIds = _.map(this.props.channels, 'id');
          this.props.updateBlacklist({ removeIds });
        }}
      />
    );
    const selectNoneButton = (
      <RaisedButton
        labelColor={COLORS.purple}
        label="None"
        onClick={() => {
          const addIds = _.map(this.props.channels, 'id');
          this.props.updateBlacklist({ addIds });
        }}
      />
    );

    return (
      <div className="slack-channels">
        <Card>
          <CardHeader
            title={`Manage ${team.teamName} Settings`}
            titleColor={COLORS.purple}
            actAsExpander
            showExpandableButton
          />
          <CardText expandable>
            <p>
              {
                'TeamHub monitors only the messages in your public Slack channels. ' +
                'It uses them to distinguish trending messages and official messages ' +
                'from the rest of the communication flow in your Slack team.'
              }
            </p>
            <p>
              {
                'Configure specific public Slack channels you want TeamHub to monitor and use ' +
                'as content source for your TV application. You can switch the monitoring on ' +
                'and off at any time.'
              }
            </p>
          </CardText>
          <CardText expandable>
            <Toolbar>
              <ToolbarGroup firstChild className="search-bar">
                <SearchIcon color={COLORS.purple} className="search-icon" />
                <TextField
                  className="filter-input"
                  hintText="Filter channels"
                  underlineStyle={{ borderColor: COLORS.purple }}
                  underlineFocusStyle={{ borderColor: COLORS.purple }}
                  onChange={(_event, newValue) => {
                    this.setState({ filterText: newValue });
                  }}
                />
              </ToolbarGroup>
              <MediaQuery minDeviceWidth={901}>
                <ToolbarGroup lastChild>
                  { selectAllButton }
                  { selectNoneButton }
                </ToolbarGroup>
              </MediaQuery>
            </Toolbar>
            <MediaQuery maxDeviceWidth={900} className="filter-buttons">
              { selectAllButton }
              { selectNoneButton }
            </MediaQuery>
          </CardText>
          <CardText expandable >
            <div className="channels">
              <List>
                { this.getSlackChannels() }
              </List>
            </div>
          </CardText>
        </Card>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/slack_channels/slack_channels.jsx